export class SubscriberDetails {
    subscriberID: number;
    password: string;
    name: string;
    accountManager: string;
    company: string;
    address1: string;
    city: string;
    county: string;
    postcode: string;
    phoneNo: number;
    directPhoneNo: number;
    faxNo: number;
    email: string;
}
